<template>
  <groups-list :parent-group-id="user.groups[0]" />
</template>

<script>
import GroupsList from '../../../components/access/GroupsList';
export default {
  name: 'org-groups',
  components: {
    GroupsList
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$analytics.event('Org Management', 'groups_page');
  },
};
</script>

<style scoped>
</style>